module.exports = __webpack_public_path__ + "static/media/page-misc-error-light.0a372054.png";